"use client"

import { useLocation, useNavigate } from "react-router-dom"
import Cookies from "js-cookie"
import Header from "./Header/Header"
import "./Layout.css"

function Layout({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const isLoginPage = location.pathname === "/"
  const isLoggedIn = !!Cookies.get("jwt_token")

  const handleLogout = () => {
    Cookies.remove("jwt_token", { path: "/" })
    navigate("/")
  }

  return (
    <div className="app-layout">
      <Header />
      <main className={`app-main ${isLoginPage ? "login-layout" : ""}`}>{children}</main>

      {isLoggedIn && !isLoginPage && (
        <div className="logout-container">
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  )
}

export default Layout
